import React, { useState, useEffect } from "react";
import { Form, notification } from "antd";
import CommonDatePicker from "@/common/elements/DatePicker";
import Checkbox from "@/common/elements/InputElements/CheckBox";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import Select from "@/common/elements/InputElements/Select";
import TextField from "@/common/elements/InputElements/TextField";
import TimePicker from "@/common/elements/TimePicker";
import {
  StyledGridCol,
  StyledGridRow,
  StyledSectionHeading,
} from "@/common/styles";
import dayjs from "dayjs";
import { getRefListNameByID } from "@/util/common_function";
import { useDispatch, useSelector } from "react-redux";
import { fetchTableNames } from "@/apis/config/tableNameApi";
import {
  fetchModules,
  fetchSubmodules,
  fetchReports,
  fetchTableViews,
} from "@/apis/config/configApi";
import { usePermissionMask } from "@/util/usePermissionMask";
import { usePermissionSync } from "@/util/usePermissionSync";
import PermissionGroup from "../PermissionGroup";
import { setConfigSubModules } from "@/slices/configSlice";

export default function RulesModulesTableViewsFieldForm2({
  form,
  initialValues = {},
  onFinish,
  disabled = false,
}) {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchTableNames());
    dispatch(fetchModules());
    dispatch(fetchReports());
    dispatch(fetchTableViews());
    return () => {
      // dispatch(setConfigSubModules(null));
    };
  }, [dispatch]);
// useEffect(()=>{
// console.log({initialValues},"testIni")
// },[initialValues])
  const tableNameOptions = useSelector((state) => state.tableNames.options);
  const moduleOptions = useSelector((state) =>
    state.config.configModules?.map((m) => ({
      value: m.moduleID,
      label: m.moduleName,
    }))
  );
  const submoduleOptions = useSelector((state) => {
    const options =
      state.config.configSubModules?.map((s) => ({
        value: s.subModuleID,
        label: s.subModuleName,
      })) || [];
console.log({config:state.config.configSubModules,options})
    return [{ value: null, label: "" }, ...options];
  });
  console.log({submoduleOptions})
  const reportOptions = useSelector((state) =>
    state.config.reports?.map((r) => ({
      value: r.reportID,
      label: r.reportFileName,
    }))
  );
  const tableViewOptions = useSelector((state) =>
    state.config.tablesViewsNew?.map((tv) => ({
      value: tv.tableViewID,
      label: tv.tableViewName,
    }))
  );

  const [ruleTypeValue, setRuleTypeValue] = useState(
    initialValues?.entityType || ""
  );
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));

  // Permissions
  const {
    items: permissionItems,
    parsePermissionMask,
    buildPermissionMask,
  } = usePermissionMask();
  const onValuesChange = usePermissionSync(form, permissionItems);

  // Seed form
  useEffect(() => {
    console.log({ initialValues }, "testParse")

    if (!initialValues) return;
    console.log(
      "parsePermissionMask(initialValues.allowSetting)",
      parsePermissionMask(initialValues?.allowSetting)
    );
    form.setFieldsValue({
      entityType: initialValues.entityType,
      ruleActive: initialValues.ruleActive ?? true,
      arbitrary: initialValues.arbitrary,
      schemaName: initialValues.schemaName,
      startingPoint: initialValues.startingPoint,
      fieldName: initialValues.fieldName,
      moduleId: initialValues.moduleId,
      subModuleId: initialValues.subModuleId,
      reportId: initialValues.reportId,
      tableViewId: initialValues.tableViewId,
      // parse permission masks into nested objects
      allowSetting: parsePermissionMask(initialValues.allowSetting),
      denySetting: parsePermissionMask(initialValues.denySetting),
      id: initialValues.securityRulesFunctionalityID,
      dateAdded: initialValues.dateAdded
        ? dayjs(initialValues.dateAdded)
        : dayjs(),
      timeAdded: initialValues.timeAdded
        ? dayjs(initialValues.timeAdded, "HH:mm")
        : dayjs(),
      user:
        initialValues.user ||
        getRefListNameByID("", userDetails?.staffId, true, false),
    });
    setRuleTypeValue(initialValues.entityType);
  }, [form, parsePermissionMask]);

  const onChangeSelectRuleType = (selected) => {
    setRuleTypeValue(selected);
    form.setFieldsValue({
      entityType: selected,
      arbitrary: null,
      schemaName: null,
      startingPoint: null,
      fieldName: null,
      moduleId: null,
      subModuleId: null,
      reportId: null,
      tableViewId: null,
    });
  };

  const testNullFormValues = (values) => {
    let allow = values?.allowSetting
    let deny = values?.denySetting
    let isSave = false
    if (allow) {
      for (let i in allow) {
        if (allow[i] == true) {
          isSave = true
          break
        }
      }
    }
    if (deny) {
      for (let i in deny) {
        if (deny[i] == true) {
          isSave = true
          break
        }
      }
    }
    return isSave
  }
  const handleFinish = (values) => {
    let isSave = testNullFormValues(values)
    if (!isSave) {
      notification.error({
        message: "Error",
        description: "Please check at least one permission setting.",
      });
      return
    }
    onFinish({
      ...values,
      // rebuild numeric masks from nested objects
      allowSetting: buildPermissionMask(values.allowSetting),
      denySetting: buildPermissionMask(values.denySetting),
    });
  }
  return (
    <Form
      form={form}
      onFinish={handleFinish}
      layout="vertical"
      disabled={disabled}
      onValuesChange={onValuesChange}
    >
      <StyledSectionHeading>
        <span>Rule Type and Status</span>
      </StyledSectionHeading>
      <StyledGridRow gutter={16}>
        <StyledGridCol lg={8}>
          <FormItem name="entityType" label="Rule Type" rules={[{ required: true, message: "Rule Type is required!" }]}>
            <Select
              onChange={onChangeSelectRuleType}
              options={[
                { value: "", label: "" },
                { value: "Arbitrary", label: "Arbitrary" },
                { value: "field", label: "Field" },
                { value: "module", label: "Module" },
                { value: "report", label: "Report" },
                { value: "submodule", label: "Submodule" },
                { value: "table-view", label: "TableView" },
              ]}
              disabled={disabled}
            />
          </FormItem>
        </StyledGridCol>
        <StyledGridCol lg={8}>
          <FormItem
            name="ruleActive"
            label="Is Rule Active?"
            layout="horizontal"
            labelPostion="label-right"
            paddingTop="26px"
            valuePropName="checked"
          >
            <Checkbox />
          </FormItem>
        </StyledGridCol>
      </StyledGridRow>

      {ruleTypeValue === "Arbitrary" && (
        <>
          <StyledSectionHeading>
            <span>Arbitrary Rule Info</span>
          </StyledSectionHeading>
          <FormItem name="arbitrary" label="Arbitrary Name" rules={[{ required: true, message: "Arbitrary Name is required!" }]}>
            <TextField />
          </FormItem>
        </>
      )}

      {ruleTypeValue === "field" && (
        <>
          <StyledSectionHeading>
            <span>Field Rule Info</span>
          </StyledSectionHeading>
          <StyledGridRow gutter={16}>
            <StyledGridCol lg={8}>
              <FormItem name="schemaName" label="Table Name" rules={[{ required: true, message: "Table Name is required!" }]}>
                <Select options={tableNameOptions} disabled={disabled}
                />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol lg={8}>
              <FormItem name="startingPoint" label="Starting Point">
                <TextField />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol lg={8}>
              <FormItem name="fieldName" label="Field Name" rules={[{ required: true, message: "Field Name is required!" }]}>
                <TextField />
              </FormItem>
            </StyledGridCol>
          </StyledGridRow>
        </>
      )}

      {ruleTypeValue === "module" && (
        <>
          <StyledSectionHeading>
            <span>Module Rule Info</span>
          </StyledSectionHeading>
          <StyledGridRow gutter={16}>
            <StyledGridCol lg={8}>
              <FormItem name="moduleId" label="Module" rules={[{ required: true, message: "Module is required!" }]}>
                <Select options={moduleOptions} disabled={disabled}
                />
              </FormItem>
            </StyledGridCol>
          </StyledGridRow>
        </>
      )}

      {ruleTypeValue === "submodule" && (
        <>
          <StyledSectionHeading>
            <span>Submodule Rule Info</span>
          </StyledSectionHeading>
          <StyledGridRow gutter={16}>
            <StyledGridCol lg={8}>
              <FormItem name="moduleId" label="Module" rules={[{ required: true, message: "Module is required!" }]}>
                <Select
                  options={moduleOptions}
                  onChange={(moduleId) => {
                    form.setFieldsValue({ subModuleId: undefined });
                    dispatch(fetchSubmodules(moduleId));
                  }}
                  disabled={disabled}
                />
              </FormItem>
            </StyledGridCol>
            <StyledGridCol lg={8}>
              <FormItem name="subModuleId" label="Sub Module">
                <Select options={submoduleOptions} disabled={disabled} />
              </FormItem>
            </StyledGridCol>
          </StyledGridRow>
        </>
      )}

      {ruleTypeValue === "report" && (
        <>
          <StyledSectionHeading>
            <span>Report Rule Information</span>
          </StyledSectionHeading>
          <StyledGridRow gutter={16}>
            <StyledGridCol lg={8}>
              <FormItem name="reportId" label="Report" rules={[{ required: true, message: "Report is required!" }]}>
                <Select options={reportOptions} disabled={disabled}
                />
              </FormItem>
            </StyledGridCol>
          </StyledGridRow>
        </>
      )}

      {ruleTypeValue === "table-view" && (
        <>
          <StyledSectionHeading>
            <span>TableView Rule Info</span>
          </StyledSectionHeading>
          <StyledGridRow gutter={16}>
            <StyledGridCol lg={8}>
              <FormItem name="tableViewId" label="Table View" rules={[{ required: true, message: "Table View is required!" }]}>
                <Select options={tableViewOptions} disabled={disabled}
                />
              </FormItem>
            </StyledGridCol>
          </StyledGridRow>
        </>
      )}

      {/* Permissions */}
      <StyledGridRow gutter={16}>
        <PermissionGroup
          form={form}
          prefix="allowSetting"
          heading="Allowed Settings"
          permissionItems={permissionItems}
        />
        <PermissionGroup
          form={form}
          prefix="denySetting"
          heading="Denied Settings"
          permissionItems={permissionItems}
        />
        {/* {console.log({permissionItems})} */}
      </StyledGridRow>

      <StyledSectionHeading marginTop="20px">
        <span>Security Rule (Functionality) Administrative Informationnn</span>
      </StyledSectionHeading>
      <StyledGridRow gutter={16}>
        <StyledGridCol lg={2}>
          <FormItem name="id" label="Id">
            <TextField disabled />
          </FormItem>
        </StyledGridCol>
        <StyledGridCol lg={6}>
          <FormItem name="dateAdded" label="Date Entered">
            <CommonDatePicker format="MM/DD/YYYY" disabled />
          </FormItem>
        </StyledGridCol>
        <StyledGridCol lg={6}>
          <FormItem name="timeAdded" label="Time Entered">
            <TimePicker format="HH:mm" disabled />
          </FormItem>
        </StyledGridCol>
        <StyledGridCol lg={6}>
          <FormItem name="user" label="User">
            <TextField disabled />
          </FormItem>
        </StyledGridCol>
      </StyledGridRow>
    </Form>
  );
}
